export const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, 4, false] }],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'align': [] }],
    [{ 'color': [] }, { 'background': [] }],
    ['link', 'image'],
    [{ 'direction': 'rtl' }],
    ['clean']
  ],
  clipboard: {
    matchVisual: false
  },
  keyboard: { bindings: { tab: false } }
};

export const formats = [
  'header',
  'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'align',
  'color', 'background',
  'link', 'image',
  'direction'
];


export const modulesBasic = {
  toolbar: [
    [{ 'header': [1, 2, 3, 4, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    ['clean']
  ],
  keyboard: { bindings: { tab: false } }
};

export const formatsBasic = [
  'header',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
];

export default { modules, formats, formatsBasic, modulesBasic };
